<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        <!-- {{ title }} -->
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <div class="text-xs-right mr-2" v-if="!responsive">
          {{(oidcUser || '').email | toLowerCase}}
          <br/>
          {{(atmosSubscription || '').name | toUpperCase}}
        </div>

        <v-menu
          offset-y
          content-class="dropdown-menu"
          transition="slide-y-transition">
          <v-btn
            slot="activator"
            icon 
            round
            color="tertiary"
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
          <v-card>
            <v-list dense>
              <v-list-tile @click="showPickSubscriptionDialog=true">
                <v-list-tile-title>Change Subscription</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showSettingsDialog=true">
                <v-list-tile-title>Settings</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>

      </v-flex>
    </v-toolbar-items>

    <dialog-pick-subscription
      v-model="showPickSubscriptionDialog"
    />

    <dialog-settings
      v-model="showSettingsDialog" 
    />

  </v-toolbar>
</template>

<script>
import PickSubscriptionDialog from '@/dialogs/PickSubscriptionDialog'
import SettingsDialog from '@/dialogs/SettingsDialog'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    'dialog-pick-subscription': PickSubscriptionDialog,
    'dialog-settings': SettingsDialog,
  },

  data: () => ({
    showPickSubscriptionDialog : false,
    showSettingsDialog: false,
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  computed: {
    ...mapGetters(['oidcUser']),
    ...mapGetters('atmos', [
      'atmosSubscription'
    ])
  },

  filters: {
    toLowerCase: function (value) {
      if (value) {
        return value.toLowerCase();
      }
      return null;
    },
    toUpperCase: function (value) {
      if (value) {
        return value.toUpperCase();
      }
      return null;
    },
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
